import { Component, OnInit, Input, ViewChild, AfterViewInit, ComponentFactoryResolver, ViewContainerRef } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { FormControl, Validators, FormGroup, FormBuilder } from '@angular/forms';
import { Router } from '@angular/router';

import { VaService } from '../_services/va.service';
import { UserService } from '../_services/user.service';
import { SearchService } from '../_services/search.service';
import { NotificationService, NotificationType } from '../_services/notification.service';
import { LongProgressService } from '../_services/long-progress.service';

import * as groupArray from 'group-array';
import { Title } from '@angular/platform-browser';
import { TourGuideService } from '../_services/tour-guide.service';
import { TourService } from 'ngx-tour-ng-bootstrap';
import { InfoIconComponent } from '../_directives/info-icon/info-icon.component';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-list-va',
  templateUrl: './list-va.component.html',
  styleUrls: ['./list-va.component.scss']
})
export class ListVaComponent implements OnInit, AfterViewInit {
  @ViewChild("startTourContent", { static: false }) startTourContent: any;
  trashBoxStatus = false;
  fileStatus = false;
  sizeErrorMsg = '';
  fileuploading = false;
  showNotification: boolean = false;
  notificationCount: number = 0;
  public profile_pic;
  @Input() filterClientName: String;
  @Input() searchText: String="";
  isloading: boolean;
  sortedProjects = [];
  recentlyCreatedProjects = [];
  groupedProjects = [];
  pinnedProjects = [];
  activeModal;
  searchList = false;
  newProjectForm: FormGroup;
  existingProjectForm: FormGroup;
  createRadio = true;
  loadedFile: any;
  filtered = false;
  showFiter = true;
  theme: boolean = false;
  newProjectFlag: boolean = false;
  progessList:any = [];
  notificationStatus :boolean = false;
  endProgressEventSubscription: Subscription;

  sectors: Array<Object> = [
    {
      'text': 'Pinned',
      'value': 'pinned'
    },
    {
      'text': 'General',
      'value': 'general'
    },
    {
      'text': 'Insurance',
      'value': 'insurance'
    },
    {
      'text': 'Banking',
      'value': 'banking'
    },
    {
      'text': 'Support',
      'value': 'support'
    },
  ];

  languages: Array<Object> = [
    {
      'text': 'English',
      'value': 'en'
    },
    {
      'text': 'German',
      'value': 'de'
    },
  ];
  projectTypes: Array<Object> = [
    {
      'text': 'Normal',
      'value': 'normal'
    },
    {
      'text': 'Universal',
      'value': 'universal'
    },
  ];

  filterOwnership = '';
  filterRoles = '';
  filterTypes = '';
  filterStates = '';

  ownershipFilter: Array<Object> = [
    {
      'text': 'Any',
      'value': ''
    },
    {
      'text': 'Owner',
      'value': 'owned_by_me'
    },
    {
      'text': 'Shared with users',
      'value': 'shared_by_me'
    },
    {
      'text': 'Shared with me',
      'value': 'shared_by_others'
    }
  ];

  botTypeFilter: Array<Object> = [
    {
      'text': 'Any',
      'value': ''
    },
    {
      'text': 'Normal bot',
      'value': 'normal'
    },
    {
      'text': 'Universal bot',
      'value': 'universal'
    }
  ];

  rolesFilter: Array<Object> = [
    {
      'text': 'Any',
      'value': ''
    },
    {
      'text': 'Admin',
      'value': 'admin'
    },
    {
      'text': 'Editor',
      'value': 'editor'
    },
    {
      'text': 'Viewer',
      'value': 'viewer'
    },
    {
      'text': 'Instructor',
      'value': 'instructor'
    },
    {
      'text': 'Support',
      'value': 'support'
    }
  ];

  statesFilter: Array<Object> = [
    {
      'text': 'Any',
      'value': ''
    },
    {
      'text': 'Active',
      'value': 'active'
    },
    {
      'text': 'Production',
      'value': 'in_production'
    },
    {
      'text': 'Delete',
      'value': 'archived'
    },
    {
      'text': 'Down',
      'value': 'down'
    }
  ];


  clientNames = [];
  filteredProjectsList: any = [];
  filteredProjectsListMain: any = [];
  packageLibraryList: any = [];
  packageLibraryListMain: any = [];
  openPackageLibrary:boolean=false;
  
  componentRef: any;

  constructor(public vaService: VaService,
    private modalService: NgbModal,
    public _userService: UserService,
    private _router: Router,
    private searchService: SearchService,
    private _notificationService: NotificationService,
    private formBuilder: FormBuilder,
    private _longProgressService: LongProgressService,
    private titlePage: Title,
    public tourGuideService: TourGuideService,
    public tourService: TourService,
    private resolver: ComponentFactoryResolver,
    private container: ViewContainerRef,
    private userService: UserService,
  ) {
    this.filterClientName = '';
    for (const project of this.vaService.agents) {
      if (project.client_name && this.clientNames.indexOf(project.client_name.trim()) < 0) {
        this.clientNames.push(project.client_name);
      }
    }
    this._userService.UserImgUpdateEvent.subscribe((img) => {
      this.profile_pic = img;
    });
    this._userService.UserNameUpdateEvent.subscribe(() => {
     
      this.profile_pic = this._userService.currentUser.avatar;
    });

  }
  ngAfterViewInit(): void {
    if(this._userService.currentUser.show_tour){
       this.open(this.startTourContent);
       this._userService.currentUser.show_tour = false;
    }
  }

  ngOnInit() {
    this.titlePage.setTitle("CIRA - Home")
    this.vaService.headingChangedEvent.emit({"heading":"Feature Library","docUrl":"Build%20Your%20Knowledge%20Repository/#feature-library"});
    this.splitCreatedProject(this.vaService.agents);
    this.searchService.searchInputChange.subscribe((searchText) => {
      const searchKey = searchText.toLocaleLowerCase().trim();
      var filteredProjects = this.vaService.agents.filter((project) => project.title.toLocaleLowerCase().includes(searchKey) || project.sector.toLocaleLowerCase().includes(searchKey) || project.client_name.toLocaleLowerCase().includes(searchKey));
      this.packageLibraryList = this.packageLibraryListMain.filter((project) => project.title.toLocaleLowerCase().includes(searchKey) || project.sector.toLocaleLowerCase().includes(searchKey) || project.client_name.toLocaleLowerCase().includes(searchKey));
      this.openPackageLibrary=true;
      this.splitCreatedProject(filteredProjects);
      if (this.filtered) {
        this.filteredProjectsList = this.filteredProjectsListMain.filter((project) => project.title.toLocaleLowerCase().includes(searchKey) || project.sector.toLocaleLowerCase().includes(searchKey) || project.client_name.toLocaleLowerCase().includes(searchKey));
      }
    });

    this.searchService.filterClientChange.subscribe((clientName) => {
      if (clientName == '') {
        var filteredProjects = this.vaService.agents;
      } else {
        var filteredProjects = this.vaService.agents.filter((project) => project.client_name.toLocaleLowerCase().trim() == clientName.toLocaleLowerCase().trim());
      }

      this.splitCreatedProject(filteredProjects);
    });

    this.vaService.projectDeleteEvent.subscribe((data) => {

      this.splitCreatedProject(this.vaService.agents);
    });

    this.vaService.agentChangedEvent.subscribe((data) => {

      this.splitCreatedProject(this.vaService.agents);

    });

    this.newProjectForm = this.formBuilder.group({
      title: new FormControl('', [Validators.required, Validators.maxLength(32)]),
      description: new FormControl('', [Validators.required, Validators.maxLength(120)]),
      client_name: new FormControl('', [Validators.required]),
      sector: new FormControl('general', [Validators.required]),
      language: new FormControl('en', [Validators.required]),
      project_type: new FormControl('normal',[Validators.required]),
    });

    this.existingProjectForm = this.formBuilder.group({
      title: new FormControl('', [Validators.required, Validators.maxLength(32)]),
      client_name: new FormControl('', [Validators.required]),
      description: new FormControl('', [Validators.required, Validators.maxLength(120)])
    });

    const data = { 'test': '', 'settings': '' };
    localStorage.setItem('tabState', JSON.stringify(data));

    this.profile_pic = this._userService.currentUser.avatar;
    this.theme = this._userService.currentUser.theme == 'dark' ? true : false;

    this.notificationSubscription();
    this.progressEndEvent();
    if(this.userService.currentUser.library_admin){
      this.libraryProject("");
      this.projectTypes.push({
        'text': 'Package',
        'value': 'library_project'
      })
      this.botTypeFilter.push({
        'text': 'Package project',
        'value': 'library_project'
      })
      console.log(this.projectTypes, this.botTypeFilter)
    }
  }

  private splitCreatedProject(projects) {

    this.pinnedProjects = [];
    var unpinnedItems = groupArray(projects, 'pinned').false;
    var groupedProjectsObject = groupArray(unpinnedItems, 'sector');
    var pinnedProjectsObj = groupArray(projects, 'pinned').true;

    this.pinnedProjects.push(pinnedProjectsObj);
    this.groupedProjects = [];

    for (let key in groupedProjectsObject) {

      // if(groupedProjectsObject[key].pinned == false){
      this.groupedProjects.push({
        sector: key,
        projects: groupedProjectsObject[key]
      });
      //}


    }
  }

  /*Pin Functionality*/
  getPinnedItem(event) {

    this.isloading = true;
    this.pinnedProjects = [];
    this.groupedProjects = [];
    this.vaService.getAgents().subscribe(
      (response: Object[]) => {
        var obj = groupArray(response, 'pinned').false;
        var pinnedProjectsObj = groupArray(response, 'pinned').true;
  
        this.pinnedProjects.push(pinnedProjectsObj);
        this.splitCreatedProject(response);
  
        this.isloading = false;
      },
      (error) => {
        console.error(error);
        this.isloading = false;
      }
    );
  }
  createNewProject(content) {
    this.newProjectForm.reset();
    this.existingProjectForm.reset();
    this.newProjectForm.controls['sector'].setValue('general');
    this.newProjectForm.controls['language'].setValue('en');
    this.activeModal = this.modalService.open(content, { windowClass: "create-project-modal"});
  }

  onCreate() {
    if (this.newProjectForm.valid) {
      let agentInfo = this.newProjectForm.value;
      // Creating notification.
      let notificationID = this._notificationService.showNotification({
        message: 'Creating',
        type: NotificationType.info,
        isLoading: true
      });
      this._notificationService.notificationID.push(notificationID);

      this.vaService.newAgent(agentInfo).subscribe(
        (result) => {
          this._userService.setConfig('active_va', result['id']).then(
            (sucess) => {
              agentInfo['_id'] = {
                '$oid': result['id']
              };
              this.vaService.getAgents();

              this.vaService.activeAgent = agentInfo;
              this._userService.setConfig('active_va', result['id']);
              this._router.navigate(['/project/', result['id'], 'template-selection']);

              // Closing notification with success.
              let notifyID = this._notificationService.notificationID.shift();
              this._notificationService.changeStatus(notifyID, NotificationType.success, result['message']);

              this.activeModal.close();
            }
          );

        }, (error) => {          
          if (error.status !== 403 && error.status !== 415 && error.status !== 500) {
            let notifyID = this._notificationService.notificationID.shift();
            this._notificationService.changeStatus(notifyID, NotificationType.error, error.error.message);
          }
        }
      );
    } else {
      Object.keys(this.newProjectForm.controls).forEach(field => {
        const control = this.newProjectForm.get(field);
        control.markAsTouched({ onlySelf: true });
      });
    }
  }

  createExisting(UploadedFile: HTMLInputElement) {
    this.fileuploading = true;
    if (this.existingProjectForm.valid) {

      this._userService.loadUserInfo().then(value => {

        let currentUser = value;
        let agentInfo = this.existingProjectForm.value;
        // Creating notification.
        // let notificationID = this._notificationService.showNotification({
        //   message: "Creating",
        //   type: NotificationType.info,
        //   isLoading: true
        // })
        // this._notificationService.notificationID.push(notificationID);


        // call CoPilot import service
        this.vaService.newAgentFromExport(UploadedFile.files[0], agentInfo, currentUser['username']).subscribe(
          (result) => {

            // start worker
            let progressId = this._longProgressService.showProgress('Importing project', 'Import started', result['task_id'], null, 'botUploadStatus', 'upload');
            this.activeModal.close();
            this.fileuploading = false;

            this._longProgressService.progressCompletedEvent.subscribe((data) => {

              if (data['id'] == progressId) {

                this._userService.setConfig('active_va', result['id']).then(
                  (sucess) => {
                    agentInfo['_id'] = {
                      '$oid': result['id']
                    };

                    this.vaService.getAgents();

                    this.vaService.activeAgent = agentInfo;
                    this._userService.setConfig('active_va', result['id']);
                    this._router.navigate(['/project/', result['id'], 'template-selection']);

                    // Closing notification with success.
                    // let notifyID = this._notificationService.notificationID.shift();
                    // this._notificationService.changeStatus(notifyID, NotificationType.success, result['message']);




                  }
                );
              }
              this.loadedFile = '';
              this.fileStatus = false;
              this.vaService.getAgents().subscribe(
                (response: Object[]) => {
                  this.splitCreatedProject(response);
                }, (err) => {
                  console.log(err);
                });
            });

          }, (error) => {
            this.fileuploading = false;
            if (error.status !== 403 && error.status !== 415 && error.status !== 500) {

              this._notificationService.showNotification({
                  message: error.error.message,
                  type: NotificationType.error,
                  isLoading: false
                })
              
            }
          }
        );



      });

    } else {
      Object.keys(this.existingProjectForm.controls).forEach(field => {
        const control = this.existingProjectForm.get(field);
        control.markAsTouched({ onlySelf: true });
      });
    }
  }

  uploadFile(uploadFile: HTMLInputElement) {

    if (uploadFile.size >= 1073741824) {
      this.fileStatus = false;
      this.sizeErrorMsg = 'File size should be less than 1 Gb';
    }
    else {
      this.fileStatus = true;
      this.loadedFile = uploadFile.files[0];

      this.sizeErrorMsg = '';
    }

  }

  filterClientChanged() {
    this.searchService.filterClientChange.emit(this.filterClientName);
  }

  searchInputChanged() {
    this.searchService.searchInputChange.emit(this.searchText);
  }

  resetClick() {
    this.filtered = false;
    this.filterOwnership = '';
    this.filterRoles = '';
    this.filterTypes = '';
    this.filterStates = '';
    if(this.userService.currentUser.library_admin){
    this.libraryProject("");
    }
  }

  filterChange() {
    const params = {
      owned_by_me: false,
      shared_by_me: false,
      shared_by_others: false,
      active: false,
      in_production: false,
      archived: false,
      down: false
    };

    if (this.filterOwnership === 'owned_by_me' || this.filterOwnership === 'shared_by_me') {
      this.filterRoles = '';
    }

    if (this.filterOwnership === '' && this.filterRoles === '' && this.filterStates === '' && this.filterTypes === '') {
      this.filtered = false;
    } else {
      this.filtered = true;
      if (this.filterOwnership !== '') {
        params[this.filterOwnership] = true;
      }
      if (this.filterRoles !== '') {
        params['role'] = this.filterRoles;
      }
      if (this.filterStates !== '') {
        params[this.filterStates] = true;
      }
      if (this.filterTypes !== '') {
        params['project_type'] = this.filterTypes;
      }
    }

    this.vaService.getFilteredAgents(params).subscribe((result) => {
      this.filteredProjectsList = result;
      this.filteredProjectsListMain = result;
      this.searchInputChanged();
    }, (error) => {

    });


    if(this.userService.currentUser.library_admin){
      this.libraryProject(params);
    }

  }
  toggleNotification(){
    this.showNotification = !this.showNotification;
    if(this.showNotification) {
      this._longProgressService.notificationOpenEvent.emit(true);
    } else {
      this._longProgressService.notificationOpenEvent.emit(false);
    }
  }
  notificationCountUpdated($event){
    this.notificationCount = $event
  }
  gotoHelps(){
    
      const factory = this.resolver.resolveComponentFactory(
        InfoIconComponent
    );
    this.componentRef = this.container.createComponent(factory);
    this.componentRef.instance.autoTrigger = true;
  }

  openTourPopUp(){
    this.tourGuideService.showSearchPopup.emit(true);
  }

  open(content) {
    this.modalService.open(content, { size: 'lg', windowClass: 'tour-modal' });
  }
  openSelectGuide(content) {
    this.modalService.open(content, { size: 'lg', windowClass: 'select-guide-modal' });
  }

  changeColorTheme(event){
    let theme = this.theme ? 'dark' : 'light';
    localStorage.setItem('theme', theme);
    this.userService.themeChangeEvent.next(true);
    this._userService.setTheme(theme).subscribe(
      (result) => {
        this._notificationService.showNotification({message: 'Theme changed to ' + theme, type: NotificationType.success, isLoading: false});
        if(theme === 'dark'){
          document.getElementsByTagName('body')[0].classList.remove('light');
          document.getElementsByTagName('body')[0].classList.add('dark');
          } else {
          document.getElementsByTagName('body')[0].classList.remove('dark');
          document.getElementsByTagName('body')[0].classList.add('light');
        }
      }, (error) => {
        this._notificationService.showNotification({message: "something went wrong", type: NotificationType.error, isLoading: false});
      }
    );
  }

  notificationSubscription() {
    this._longProgressService.showProgressEvent.subscribe((statusData) => {
      this.progessList.push(statusData);
      this.notificationStatus = true;
      this.notificationCount = this.notificationCount + this.progessList.length;
    })
  }

  progressEndEvent() {
    this.endProgressEventSubscription = this._notificationService.endProgressEvent.subscribe(data => {
      this.progessList = this.progessList.filter((item)=> item.taskId != data.progress.taskId )
      this.updateProgressStatus()
    })
  }

  updateProgressStatus() {
    this.notificationStatus = false;
    this.progessList.forEach(element => {
      if(element.statusClass == "LOADING") {
        this.notificationStatus = true;
      }
    });
  }
  libraryProject(params){
    if(this.filterOwnership !== '' || this.filterRoles !== '' || this.filterTypes == 'normal' || this.filterTypes == 'universal'){
      this.packageLibraryList = [];
      this.packageLibraryListMain=[];
    }else {
      this.vaService.getLibraryProjects(params).subscribe((result) => {
        this.packageLibraryListMain=result
        this.packageLibraryList=result
      }, (error) => {
      });
    }
  }

}

